import React from 'react'
import imageUrl from 'images/search/promotional/parachute.jpeg'

const ParachuteNode = () => (
  <a className="link-unstyled" href="/activites/5895-bababox-saut-en-parachute">
    <div className="hit-card hit-card-promo">
      <div className="img-container">
        <div className="promo-banner">Promotion</div>
        <img src={imageUrl} alt="Saut en parachute" />
      </div>
      <div className="content">
        <div className="promo-title">
          Offrez une Bababox : Saut en parachute
        </div>

        <div className="hit-features">
          <div>France Offrez une expérience sensationnel riche en émotion.</div>
          <div>Des sauts dans des sites d’exception en France.</div>
          <div>Valide 1 an, renouvelable 12 mois.</div>
        </div>
      </div>
      <div className="hit-card-bottom-container">
        <div className="pricing text-center">
          <span className="price-from">A partir de&nbsp;</span>
          <div className="price">265,50 €&nbsp;</div>
          <span className="price-per">par personne</span>
        </div>
      </div>
    </div>
  </a>
)

export default ParachuteNode
